<div class="row">
  <div class="mx-auto col col-md-5">
    @if ((service.isMultiTenancyEnabled$ | async) && service.isTenantBoxVisible) {
      <abp-tenant-box
        *abpReplaceableTemplate="{ componentKey: service.tenantBoxKey }"
      ></abp-tenant-box>
    }

    <div class="abp-account-container">
      @if (service.enableLocalLogin$ | async) {
        <div class="card mt-3 shadow-sm rounded">
          <div class="card-body p-5">
            <ng-content></ng-content>
          </div>
        </div>
      } @else {
        <div class="alert alert-warning">
          <strong>{{ 'AbpAccount::InvalidLoginRequest' | abpLocalization }}</strong>
          {{ 'AbpAccount::ThereAreNoLoginSchemesConfiguredForThisClient' | abpLocalization }}
        </div>
      }
    </div>
  </div>
</div>
